import { Languages, Monitor, Moon, Sun } from 'lucide-react';
import { usePrefs } from '../../application/stores/prefsStore';
import { useT } from '../i18n/i18n';
import { IconButton } from './Button';
import { Menu } from './Menu';

/** Compact language + theme switcher for public pages. */
export function PrefsSwitcher() {
  const t = useT();
  const { locale, theme, setLocale, setTheme } = usePrefs();
  const ThemeIcon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor;
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      <Menu
        trigger={(p) => (
          <IconButton label={t('locale.label')} {...p}>
            <Languages size={18} />
          </IconButton>
        )}
        items={(['ru', 'en'] as const).map((l) => ({
          label: t(`locale.${l}`),
          checked: locale === l,
          onSelect: () => setLocale(l),
        }))}
      />
      <Menu
        trigger={(p) => (
          <IconButton label={t('theme.label')} {...p}>
            <ThemeIcon size={18} />
          </IconButton>
        )}
        items={(['system', 'light', 'dark'] as const).map((th) => ({
          label: t(`theme.${th}`),
          checked: theme === th,
          onSelect: () => setTheme(th),
        }))}
      />
    </div>
  );
}
